import { render } from "./ScrollToBottomButton.vue?vue&type=template&id=3d8276c8"
import script from "./ScrollToBottomButton.vue?vue&type=script&lang=js"
export * from "./ScrollToBottomButton.vue?vue&type=script&lang=js"

import "./ScrollToBottomButton.vue?vue&type=style&index=0&id=3d8276c8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__